// Layout.js - A wrapper for valid routes (with Header and Side Nav)
import React from "react";
import "./loginPageLayout.scss";
import TopHeaderBar from '../../webview-components/top-header-bar';
import { useShopDetailsContext } from '../../context/ShopDetailsContext';

const MainPageLayout = ({ children }) => {
  const { shopDetailsContext } = useShopDetailsContext();

  return (
    <>
      <div className="d-flex flex-row login-page-layout foreground-frame">
        <div className="body-right-side flex-grow-1 d-flex flex-column vh-100">
          <TopHeaderBar
            user_image={shopDetailsContext.user_image}
            shop_name={shopDetailsContext.shop_name}
            meta_data={shopDetailsContext.meta_data}
            order_created_at={shopDetailsContext.order_created_at}
            order_type={shopDetailsContext.order_type}
          />

          {/* Main Content */}
          <main className={`main-page-layout-main-content pageName___${children.type.name}`}>{children}</main>
        </div>
      </div>
    </>
  );
};

export default MainPageLayout;
